import React, { useEffect } from 'react';
import { useGoogleTag } from '../hooks/useGoogleTag';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = 'Shifting Arithmetic | Triangular Multiplication Playground',
  description = 'Interactive playground for the Shifting Algorithm, exploring novel triangular multiplication strategies and symmetric shifts.',
  keywords = 'arithmetic, shifting algorithm, pascal triangle, math visualization, triangular array, binomial coefficients, number theory, data visualization',
  image = '/images/logo.webp',
}) => {
  useGoogleTag('G-8715TYVK5T');

  useEffect(() => {
    document.title = title;

    const updateMeta = (name: string, content: string, isProperty = false) => {
      const selector = isProperty
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        if (isProperty) element.setAttribute('property', name);
        else element.setAttribute('name', name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    const absoluteImageUrl = new URL(image, window.location.origin).href;

    updateMeta('description', description);
    updateMeta('keywords', keywords);
    updateMeta('og:title', title, true);
    updateMeta('og:description', description, true);
    updateMeta('og:image', absoluteImageUrl, true);
    updateMeta('og:url', window.location.href, true);
    updateMeta('og:type', 'website', true);
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', title);
    updateMeta('twitter:description', description);
    updateMeta('twitter:image', absoluteImageUrl);
  }, [title, description, keywords, image]);

  return null;
};

export default SEO;
